import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { Container, Highlight, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { Reservation } from '@mews-commander/data-access';
import { getCurrentEnterpriseReservationIdsByGroupId } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { fetchCurrentEnterpriseReservationsByGroupIds } from '@mews-commander/legacy-entities/src/actions/reservations';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useInvalidateReservationGroupQuery } from '@mews-commander/core/entities';
import { RESERVATION_BARE_MINIMUM_EXTENT } from '../../../constants';
import { getCheckedReservationsCount } from '../../../selectors';
import { getLockableCheckedReservations } from '../../../selectors/reservationModuleState/reservationSelection';
import CheckAllCheckbox from './CheckAllCheckbox';
import LockAllToggle from './LockAllToggle';
import { SelectedCount } from './SelectedCount';

interface OwnProps {
    groupId: string;
}

interface StateProps {
    reservationIds: string[];
    checkedLockableReservations: Reservation[];
    checkedReservationsCount: number;
}

type Props = StateProps & OwnProps;
const BulkActionButtons = ({
    reservationIds,
    checkedLockableReservations,
    groupId,
    checkedReservationsCount,
}: Props) => {
    const isReservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const dispatch = useCommanderThunkDispatch();
    const invalidateReservationData = useInvalidateReservationGroupQuery(groupId);
    const invalidateReservationDataRedux = () =>
        dispatch(
            fetchCurrentEnterpriseReservationsByGroupIds({
                groupIds: [groupId],
                extent: RESERVATION_BARE_MINIMUM_EXTENT,
            })
        );
    const refetchGroup = isReservationModuleReactQueryEnabled
        ? invalidateReservationData
        : invalidateReservationDataRedux;
    return (
        <Container padding="200">
            <Stack distribution="space-between" itemAlignment="center" alignment="center" spacing="50">
                <StackItem>
                    <Stack itemAlignment="center" spacing="100">
                        <Stack itemAlignment="center" spacing="200">
                            <CheckAllCheckbox reservationIds={reservationIds} scope={groupId} />
                            <Stack vertical>
                                <Highlight size="small">
                                    <LocalizedText textKey={TextKey.ReservationPlural} />
                                </Highlight>
                                <SelectedCount
                                    selectedCount={checkedReservationsCount}
                                    totalCount={reservationIds.length}
                                />
                            </Stack>
                        </Stack>
                    </Stack>
                </StackItem>
                <StackItem>
                    <Stack itemAlignment="center" spacing="100">
                        <LockAllToggle reservations={checkedLockableReservations} refetchGroup={refetchGroup} />
                    </Stack>
                </StackItem>
            </Stack>
        </Container>
    );
};
export default connect<StateProps, null, OwnProps, ApplicationState>(
    createStructuredSelector({
        checkedReservationsCount: (state, { groupId }) => getCheckedReservationsCount(state, { scope: groupId }),
        reservationIds: getCurrentEnterpriseReservationIdsByGroupId,
        checkedLockableReservations: (state, { groupId }) => getLockableCheckedReservations(state, { scope: groupId }),
    })
)(BulkActionButtons);
